// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-NoVacancyDescription-module--cls1--3uiiA","cls2":"styles-NoVacancyDescription-module--cls2--1fBvi styles-NoVacancyDescription-module--cls1--3uiiA"};